import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const trustMetrics = [
    {
      icon: 'Users',
      value: '50+',
      label: 'Satisfied Clients',
      color: 'var(--color-success)'
    },
    {
      icon: 'Award',
      value: '50+',
      label: 'Projects Delivered',
      color: 'var(--color-accent)'
    },
    {
      icon: 'Clock',
      value: '4-6hrs',
      label: 'Response Time',
      color: 'var(--color-warning)'
    },
    {
      icon: 'Star',
      value: '4.9/5',
      label: 'Client Rating',
      color: 'var(--color-primary)'
    }
  ];

  const certifications = [
    { name: 'ISO 27001 Certified', icon: 'Shield' },
    { name: 'AWS Partner', icon: 'Cloud' },
    { name: 'SOC 2 Compliant', icon: 'Lock' },
    { name: 'GDPR Compliant', icon: 'FileCheck' }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-gradient-to-br from-primary/5 via-background to-accent/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 lg:gap-8 mb-12 md:mb-16">
          {trustMetrics?.map((metric, index) => (
            <div
              key={index}
              className="bg-card border border-border rounded-xl p-4 md:p-6 text-center hover:border-primary/50 transition-all duration-300 hover:shadow-lg"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 lg:w-14 lg:h-14 bg-muted rounded-lg flex items-center justify-center mx-auto mb-3 md:mb-4">
                <Icon name={metric?.icon} size={24} color={metric?.color} className="md:w-7 md:h-7 lg:w-8 lg:h-8" />
              </div>
              <div className="text-2xl md:text-3xl lg:text-4xl font-bold font-headline text-foreground mb-1 md:mb-2">
                {metric?.value}
              </div>
              <div className="text-xs md:text-sm text-muted-foreground font-body">
                {metric?.label}
              </div>
            </div>
          ))}
        </div>

        {/* <div className="bg-card border border-border rounded-xl p-6 md:p-8 lg:p-10">
          <div className="text-center mb-6 md:mb-8">
            <h3 className="text-xl md:text-2xl lg:text-3xl font-bold font-headline text-foreground mb-2 md:mb-3">
              Trusted & Certified
            </h3>
            <p className="text-sm md:text-base text-muted-foreground font-body max-w-2xl mx-auto">
              We maintain the highest standards of security, compliance, and quality in everything we do.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {certifications?.map((cert, index) => (
              <div
                key={index}
                className="flex flex-col items-center justify-center p-4 md:p-6 bg-muted/50 rounded-lg hover:bg-muted transition-colors duration-200"
              >
                <Icon name={cert?.icon} size={32} color="var(--color-primary)" className="mb-3 md:mb-4" />
                <span className="text-xs md:text-sm font-medium text-foreground font-body text-center">
                  {cert?.name}
                </span>
              </div>
            ))}
          </div>

          <div className="mt-8 md:mt-10 pt-8 md:pt-10 border-t border-border">
            <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-center md:text-left">
              <div className="flex items-center space-x-2">
                <Icon name="Shield" size={20} color="var(--color-success)" />
                <span className="text-sm md:text-base text-muted-foreground font-body">
                  100% Secure Communication
                </span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Lock" size={20} color="var(--color-success)" />
                <span className="text-sm md:text-base text-muted-foreground font-body">
                  NDA Available Upon Request
                </span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="CheckCircle2" size={20} color="var(--color-success)" />
                <span className="text-sm md:text-base text-muted-foreground font-body">
                  No Obligation Consultation
                </span>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default TrustSignals;